import React from 'react'

function SvgTick(props) {
    return (
            <svg width="11" 
            height="11" 
            viewBox="0 0 11 11" 
            fill="none" {...props}>
            <path d="M5.3012 0C2.37494 0 0 2.464 0 5.5C0 8.536 2.37494 11 5.3012 11C8.22747 11 10.6024 8.536 10.6024 5.5C10.6024 2.464 8.22747 0 5.3012 0Z" fill="#F9FAFB"/>
            <path d="M7.73433 3.06909L4.24084 6.69359L2.86783 5.27459L2.12036 6.05009L4.24084 8.25009L8.4818 3.85009L7.73433 3.06909Z" fill="#0075C9"/>
            </svg>

    )
}

export default SvgTick
